export default "__VITE_ASSET__37c2d59e__"